import { ImageHero } from '@components/image-hero/models';
import { imageMock } from '@mock/schema/components/shared';
import { Block } from '@shared/models';

export const imageHeroMock: Block<ImageHero> = {
  type: 'image-hero',
  data: {
    image: imageMock,
  },
};
